import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LeaderboardEventScores } from 'api';
import { useNetworkCapabilities } from 'hooks';

interface IProps {
  eventScores: LeaderboardEventScores[];
}

const useStyles = makeStyles(theme => ({
  cell: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&:first-child, &:last-child': {
      borderRadius: 0,
    },
  },
}));

const PointTable: FC<IProps> = ({ eventScores }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { hasTwitter } = useNetworkCapabilities();

  if (!hasTwitter) eventScores = eventScores.filter(e => e.event.indexOf('twitter') === -1);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.cell}>{t('common:action')}</TableCell>
          <TableCell className={classes.cell}>{t('common:point_plural')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {eventScores.map(leaderboardEvent => (
          <TableRow key={leaderboardEvent.event}>
            <TableCell className={classes.cell}>
              <strong>{t(`leaderboard:${leaderboardEvent.event}`)}</strong>
            </TableCell>
            <TableCell className={classes.cell}>{leaderboardEvent.score}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PointTable;
